






















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SecaoTabela extends Vue {
	@Prop({ type: String, default: '' }) titulo!: string
	@Prop({ type: String, default: 'mdi-table' }) icone!: string
	@Prop({ type: Array, default: () => [] }) headers!: any[]
	@Prop({ type: Array, default: () => [] }) items!: any[]
	@Prop({ type: Boolean, default: false }) loading!: boolean
	@Prop({ type: String, default: '' }) atualizadoEm!: string
}
